module.exports = __webpack_public_path__ + "static/media/ARROZP_MENU-normal.6e1292be.png";